(() => {
  'use strict';
  const translate = value => window.pepnixText ? window.pepnixText(value) : value;
  const root = document.querySelector('.gnagfri');
  const dataEl = document.getElementById('GnagfriProductData');
  if (!root || !dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const money = minor => new Intl.NumberFormat(window.PepnixLocale?.locale || 'sv-SE', { style: 'currency', currency: data.initialCart?.currency || window.PepnixLocale?.currency || 'SEK', maximumFractionDigits: ['EUR', 'CHF'].includes(data.initialCart?.currency || window.PepnixLocale?.currency) ? 2 : 0 }).format(minor / 100);
  const dialog = root.querySelector('.gnagfri-cart');
  const linesEl = dialog.querySelector('[data-gnagfri-lines]');
  const legacyGiftId = Number(data.legacyGiftId);
  const productIds = new Set((data.checkoutFamily || [data.variants.map(v => v.id)]).flat().map(Number));
  const route = data.root || '/';
  let previousFocus, closing, controller, lastState, selected = root.querySelector('input[name="id"]:checked');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  const isGift = item => Number(item.variant_id || item.id) === legacyGiftId;
  const isProduct = item => productIds.has(Number(item.variant_id || item.id));
  const raw = async (path, body) => {
    const response = await fetch(route + path, body === undefined ? { cache: 'no-store' } : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || translate('Varukorgen kunde inte uppdateras. Försök igen.'));
    return payload;
  };
  // Remove the retired gift from returning carts while preserving every other line.
  const removeLegacyGift = async cart => {
    const updates = Object.fromEntries(cart.items.filter(isGift).map(line => [line.key, 0]));
    return Object.keys(updates).length ? raw('cart/update.js', { updates }) : cart;
  };
  const read = async () => { const cart = await removeLegacyGift(await raw('cart.js')); window.FTBReassurance?.checkCart(cart); return cart; };
  const open = () => {
    clearTimeout(closing);
    if (!dialog.open) { previousFocus = document.activeElement; dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
    requestAnimationFrame(() => dialog.classList.add('is-visible'));
  };
  const close = () => {
    dialog.classList.remove('is-visible');
    closing = setTimeout(() => { dialog.close(); document.documentElement.style.overflow = ''; previousFocus?.focus(); }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300);
  };
  function updateCartTimer(hasItems) {
    const timer = dialog.querySelector('[data-cart-timer]');
    const storageKey = 'pepnix-cart-countdown-deadline';
    if (!hasItems) {
      clearInterval(dialog.cartTimerInterval); dialog.cartTimerInterval = null; dialog.cartTimerDeadline = null;
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      timer.hidden = true; return;
    }
    if (dialog.cartTimerDeadline == null) {
      let stored; try { stored = Number(sessionStorage.getItem(storageKey)); } catch (_) {}
      dialog.cartTimerDeadline = stored > 0 ? stored : Date.now() + 60 * 60 * 1000;
      try { sessionStorage.setItem(storageKey, String(dialog.cartTimerDeadline)); } catch (_) {}
    }
    const tick = () => {
      const seconds = Math.max(0, Math.ceil((dialog.cartTimerDeadline - Date.now()) / 1000));
      timer.hidden = seconds === 0;
      timer.querySelector('strong').textContent = `${Math.floor(seconds / 60)}m ${String(seconds % 60).padStart(2, '0')}s`;
      if (!seconds) { clearInterval(dialog.cartTimerInterval); dialog.cartTimerInterval = null; }
    };
    tick();
    if (!dialog.cartTimerInterval && dialog.cartTimerDeadline > Date.now()) dialog.cartTimerInterval = setInterval(tick, 1000);
  }
  // Native quantities count individual packs for Kaching and whole bundles for fallback variants.
  function packDetails(item) {
    const family = (data.checkoutFamily || [data.variants.map(v => v.id)]).find(ids => ids.map(Number).includes(Number(item.variant_id || item.id)));
    const variantIndex = family ? family.map(Number).indexOf(Number(item.variant_id || item.id)) : -1;
    const packs = variantIndex < 0 ? 0 : (variantIndex + 1) * item.quantity;
    const original = Math.max(Number(item.original_line_price || 0), packs * data.variants[0].price);
    const final = Math.round(Number(item.final_line_price));
    const threePackPrice = data.bundleOffers.find(offer => offer.quantity === 3)?.price;
    // Show a free pack only when the actual line price matches the approved three-pack offer.
    const freePacks = packs && packs % 3 === 0 && final === threePackPrice * (packs / 3) ? packs / 3 : 0;
    const legacyStep = variantIndex === 0 && freePacks ? 3 : variantIndex === 0 && packs === 2 && final === data.bundleOffers.find(offer => offer.quantity === 2)?.price ? 2 : 1;
    const selectedSize = Number(item.properties?._pepnix_bundle_size);
    const step = variantIndex === 0 && [1, 2, 3].includes(selectedSize) && item.quantity % selectedSize === 0 ? selectedSize : legacyStep;
    return { packs, original, final, freePacks, step, units: item.quantity / step };
  }
  function render(cart, state) {
    lastState = state;
    const visible = cart.items.filter(item => !isGift(item));
    root.querySelectorAll('[data-gnagfri-count]').forEach(el => { el.textContent = visible.reduce((n, item) => n + packDetails(item).units, 0); });
    updateCartTimer(visible.length > 0);
    let originalTotal = 0;
    const active = document.activeElement;
    const draft = active?.matches('.gnagfri-quantity input') ? { key: active.dataset.key, value: active.value, focused: true } : null;
    const existing = new Map([...linesEl.children].map(el => [el.dataset.key, el]));
    visible.forEach(item => {
      let line = existing.get(item.key);
      const safeKey = escape(item.key);
      if (!line) {
        line = document.createElement('article'); line.className = 'gnagfri-cart-line'; line.dataset.key = item.key;
        const image = ['nb', 'de', 'fi', 'da'].includes(window.PepnixLocale?.locale) && isProduct(item) ? data.image : item.image || item.featured_image?.url || data.image;
        line.innerHTML = `${image ? `<img src="${escape(image)}" alt="${escape(translate(item.product_title))}" width="75" height="88">` : '<span></span>'}<div><h3>${escape(translate(item.product_title || item.title))}</h3><p data-line-packs></p><span class="gnagfri-cart-offer" data-line-offer hidden></span><div class="gnagfri-cart-prices"><del data-line-original hidden></del><strong data-line-total></strong></div><div class="gnagfri-cart-line-bottom"><div class="gnagfri-quantity"><button type="button" data-delta="-1" aria-label="${translate('Minska antal')}">−</button><input type="number" min="0" max="99" inputmode="numeric" aria-label="${translate('Antal')} ${escape(translate(item.variant_title || ''))}" value="${item.quantity}" data-key="${safeKey}"><button type="button" data-delta="1" aria-label="${translate('Öka antal')}">+</button></div><button type="button" class="gnagfri-remove">${translate('Ta bort')}</button></div></div>`;
        linesEl.append(line);
      }
      const details = packDetails(item);
      originalTotal += details.original;
      line.querySelector('[data-line-packs]').textContent = details.packs
        ? `${details.packs} ${details.packs === 1 ? translate('förpackning') : translate('förpackningar')} · ${details.packs * 12} ${translate('påsar')}`
        : item.variant_title || '';
      const offer = line.querySelector('[data-line-offer]');
      offer.hidden = !details.freePacks;
      offer.textContent = details.freePacks === 1 ? translate('Köp 2, få 1 gratis') : `${details.freePacks} ${translate('förpackningar gratis')}`;
      const original = line.querySelector('[data-line-original]');
      original.hidden = details.original <= details.final;
      original.textContent = money(details.original);
      original.setAttribute('aria-label', `${translate('Ordinarie pris')} ${money(details.original)}`);
      line.querySelector('[data-line-total]').textContent = money(details.final);
      line.querySelector('input').setAttribute('aria-label', translate('Antal paket'));
      const input = line.querySelector('input');
      if (draft?.key !== item.key) input.value = details.units;
      existing.delete(item.key);
    });
    existing.forEach(el => el.remove());
    // Rekey optimistic rows while retaining typed drafts after the server assigns a line key.
    if (draft && !document.contains(active)) {
      const candidate = visible.find(item => controller?.resolveKey(draft.key) === item.key);
      const target = candidate && [...linesEl.querySelectorAll('input')].find(el => el.dataset.key === candidate.key);
      if (target) { target.value = draft.value; target.focus(); }
    }
    dialog.querySelector('.gnagfri-cart-empty').hidden = visible.length > 0;
    const savings = Math.max(0, originalTotal - cart.total_price);
    dialog.querySelector('[data-gnagfri-savings-row]').hidden = !savings;
    dialog.querySelector('[data-gnagfri-savings]').textContent = `−${money(savings)}`;
    dialog.querySelector('[data-gnagfri-subtotal]').textContent = money(cart.total_price);
    dialog.querySelector('[data-gnagfri-shipping]').textContent = translate('Beräknas i kassan');
    dialog.querySelector('.gnagfri-checkout').disabled = visible.length === 0;
    dialog.querySelector('.gnagfri-cart-status').textContent = state.checkoutQueued ? translate('Bekräftar din varukorg…') : state.pending ? translate('Uppdaterar varukorgen…') : '';
    const err = dialog.querySelector('.gnagfri-cart-error'); err.hidden = !state.error; err.textContent = state.error ? translate('Varukorgen kunde inte bekräftas. Kontrollera innehållet och försök igen.') : '';
    dialog.querySelector('.gnagfri-cart-retry').hidden = !state.error;
  }
  controller = new window.GnagfriCartController({ initialCart: data.initialCart, onChange: render,
    transport: {
      read,
      add: async item => { await raw('cart/add.js', { items: [{ id: item.variant_id, quantity: item.quantity, properties: item.properties || {} }] }); return read(); },
      // Mutation responses can retain checkout shipping estimates in total_price.
      // Read the merchandise cart again, as the add transport already does.
      change: async (id, quantity) => { await raw('cart/change.js', { id, quantity }); return read(); }
    },
    onCheckout: async () => {
      if (window.gnagfriCheckoutInFlight) return;
      window.gnagfriCheckoutInFlight = true;
      try { const cart = await window.PepnixCheckoutLocalization.migrate({ cart: await read(), targetVariants: data.variants.map(v => v.id), familyVariants: data.checkoutFamily || [], sourceVariants: (data.sourceVariants || data.variants).map(v => v.id), sourceProductId: data.sourceProductId || data.productId, read, add: item => raw('cart/add.js', { items: [item] }), remove: key => raw('cart/change.js', { id: key, quantity: 0 }) }); if (!cart.items.length) throw new Error(translate('Din varukorg är tom.')); window.location.assign(route + 'checkout'); }
      catch (error) { window.gnagfriCheckoutInFlight = false; controller.error = error; controller.checkoutQueued = false; controller.confirmedAt = 0; controller.emit(); }
    }
  });
  let bundleSelection = null, bundlePending = false;
  const bundleHost = root.querySelector('[data-gnagfri-kaching]');
  const fallbackOffers = root.querySelector('[data-gnagfri-fallback]');
  const baseVariant = data.variants[0];
  const fixedDecimalMarket = (data.country === 'DE' && data.initialCart?.currency === 'EUR') || (data.country === 'CH' && data.initialCart?.currency === 'CHF');
  const syncBundle = () => {
    if (!bundleHost) return;
    const line = window.GnagfriKaching?.normalize(window.GnagfriKaching.detail, baseVariant.id);
    if (!line) return;
    const offer = data.bundleOffers.find(offer => offer.quantity === line.quantity);
    if (!offer) return;
    const quotedTotal = window.GnagfriKaching.detail?.pricing?.discountedPrice?.amount;
    const total = Number.isSafeInteger(quotedTotal) && quotedTotal >= 0 ? quotedTotal : offer.price;
    bundleSelection = { ...line, total };
    bundlePending = false;
    fallbackOffers.hidden = true;
    fallbackOffers.querySelectorAll('input').forEach(input => { input.disabled = true; });
    const nativeId = root.querySelector('[data-gnagfri-kaching-variant]');
    nativeId.disabled = false;
    bundleHost.setAttribute('aria-busy', 'false');
    bundleHost.querySelector('[data-gnagfri-kaching-loading]').hidden = true;

    root.querySelector('[data-gnagfri-sticky-label]').textContent = `${line.quantity} ${line.quantity === 1 ? translate('förpackning') : translate('förpackningar')} · ${money(total)}`;
  };
  bundleHost?.addEventListener('change', event => {
    if (event.target.matches('input[type=radio]')) bundlePending = true;
  }, true);
  document.addEventListener('gnagfri:bundle-selection', syncBundle);
  const localizeBundleLabels = () => {
    if (['nb', 'de', 'fi', 'da'].includes(window.PepnixLocale?.locale)) {
      bundleHost?.querySelectorAll('.kaching-bundles__bar-title, .kaching-bundles__bar-label, .kaching-bundles__bar-badge, .kaching-bundles__block-title').forEach(el => {
        for (const node of el.childNodes) if (node.nodeType === 3) { const next = translate(node.nodeValue); if (node.nodeValue !== next) node.nodeValue = next; }
      });
    }
    bundleHost?.querySelectorAll('.kaching-bundles__bar').forEach(bar => {
      const quantity = Number(bar.querySelector('.kaching-bundles__bar-title')?.textContent.match(/^\s*(\d+)/)?.[1]);
      if (bar.dataset.pepnixQuantity !== String(quantity)) bar.dataset.pepnixQuantity = String(quantity);
      // Shopify's global SEK format omits decimals. Display actual fixed EUR/CHF catalog prices with cents.
      // Kaching's market-specific fixed totals must agree with these native prices in cart/checkout.
      if (fixedDecimalMarket) {
        const offer = data.bundleOffers.find(offer => offer.quantity === quantity);
        const price = bar.querySelector('.kaching-bundles__bar-price');
        if (offer && price && price.textContent !== money(offer.price)) price.textContent = money(offer.price);
      }
      if (quantity === 2 || quantity === 3) {
        const pricing = bar.querySelector('.kaching-bundles__bar-pricing');
        if (pricing && !pricing.querySelector('.pepnix-offer-compare')) {
          const compare = document.createElement('del');
          compare.className = 'pepnix-offer-compare';
          compare.textContent = money(baseVariant.price * quantity);
          pricing.prepend(compare);
        }
      }
      const subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (![1, 2, 3].includes(quantity) || !subtitle) return;
      const text = `${quantity * 12} ${translate('påsar')}`;
      if (subtitle.textContent !== text) subtitle.textContent = text;
    });
    bundleHost?.querySelectorAll('[data-a11y-label]').forEach(el => {
      if (['Price:', 'Pris:'].includes(el.dataset.a11yLabel)) el.dataset.a11yLabel = translate('Pris:');
      if (['Original price:', 'Ordinarie pris:'].includes(el.dataset.a11yLabel)) el.dataset.a11yLabel = translate('Ordinarie pris') + ':';
    });
  };
  if (bundleHost) new MutationObserver(localizeBundleLabels).observe(bundleHost, { childList: true, subtree: true, characterData: true });
  localizeBundleLabels();
  syncBundle();
  const choose = () => { if (bundleSelection) return; selected = root.querySelector('input[name="id"]:checked'); if (!selected) return; root.querySelector('[data-gnagfri-sticky-label]').textContent = `${selected.dataset.title} · ${money(Number(selected.dataset.price))}`; };
  choose(); root.querySelectorAll('input[name="id"]').forEach(el => el.addEventListener('change', choose));
  const add = async () => {
    if (bundlePending) {
      open();
      try {
        await new Promise((resolve, reject) => {
          const finish = () => { clearTimeout(timeout); document.removeEventListener('gnagfri:bundle-selection', finish); resolve(); };
          const timeout = setTimeout(() => { document.removeEventListener('gnagfri:bundle-selection', finish); reject(new Error(translate('Välj förpackning igen och försök på nytt.'))); }, 3000);
          document.addEventListener('gnagfri:bundle-selection', finish);
        });
      } catch (error) {
        const message = root.querySelector('.gnagfri-product-error'); message.hidden = false; message.textContent = error.message; return;
      }
    }
    root.querySelector('.gnagfri-product-error').hidden = true;
    if (!bundleSelection && (!selected || selected.disabled)) return;
    const properties = {};
    for (const [key, value] of new FormData(root.querySelector('#GnagfriProductForm'))) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    }
    Object.assign(properties, window.FTBReassurance?.tags());
    // Preserve Kaching's native discount properties and submitted form options.
    const selectedOffer = bundleSelection
      ? data.bundleOffers.find(offer => offer.quantity === bundleSelection.quantity)
      : data.bundleOffers[data.variants.findIndex(variant => variant.id === Number(selected.value))];
    if (!selectedOffer) return;
    // Keep Shopify/Kaching's pack quantities and discounts authoritative, while controls count bundles.
    properties._pepnix_bundle_size = String(selectedOffer.quantity);
    properties._pepnix_source_product = String(data.sourceProductId || data.productId);
    properties._pepnix_source_variant = String((data.sourceVariants || data.variants)[0].id);
    const total = bundleSelection ? bundleSelection.total : selectedOffer.price;
    const item = {
      variant_id: baseVariant.id, quantity: selectedOffer.quantity,
      price: baseVariant.price, final_price: total / selectedOffer.quantity,
      variant_title: baseVariant.title
    };
    open();
    void controller.add({ ...item, product_title: data.title, image: data.image, properties }).catch(() => {});
  };
  root.querySelector('#GnagfriProductForm')?.addEventListener('submit', event => { event.preventDefault(); add(); });
  root.querySelectorAll('[data-gnagfri-add]').forEach(el => el.addEventListener('click', event => { event.preventDefault(); add(); }));
  root.querySelector('.gnagfri-cart-open').addEventListener('click', () => { open(); void controller.refresh(true); });
  dialog.querySelector('.gnagfri-cart-close').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) close(); });
  linesEl.addEventListener('click', event => {
    const button = event.target.closest('button'); const line = button?.closest('[data-key]'); if (!line) return;
    const key = line.dataset.key; const item = controller.snapshot().items.find(item => item.key === key); if (!item) return;
    const quantity = button.classList.contains('gnagfri-remove') ? 0 : item.quantity + Number(button.dataset.delta) * packDetails(item).step;
    const step = packDetails(item).step;
    void controller.setQuantity(key, Math.min(Math.floor(99 / step) * step, quantity));
  });
  const commit = input => { const value = Number(input.value), item = controller.snapshot().items.find(line => line.key === input.dataset.key); if (item && Number.isInteger(value) && value >= 0) void controller.setQuantity(input.dataset.key, Math.min(Math.floor(99 / packDetails(item).step), value) * packDetails(item).step); };
  linesEl.addEventListener('change', event => { if (event.target.matches('input')) commit(event.target); });
  linesEl.addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.matches('input')) { event.preventDefault(); commit(event.target); } });
  dialog.querySelector('.gnagfri-checkout').addEventListener('click', () => controller.checkout());
  dialog.querySelector('.gnagfri-cart-retry').addEventListener('click', () => { void controller.refresh(true); });
  window.addEventListener('pageshow', () => { window.gnagfriCheckoutInFlight = false; void controller.refresh(true); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) void controller.refresh(true); });
  const countdown = root.querySelector('.gnagfri-seasonal-bar__timer');
  if (countdown) {
    const endsAt = Date.parse(countdown.dataset.endTime);
    const updateCountdown = () => {
      const remaining = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));
      if (!Number.isFinite(remaining) || remaining === 0) { countdown.closest('.gnagfri-seasonal-bar').hidden = true; return; }
      const units = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      countdown.querySelectorAll('[data-countdown-unit]').forEach((el, i) => { el.textContent = String(units[i]).padStart(2, '0'); });
    };
    updateCountdown(); setInterval(updateCountdown, 1000);
  }
  const sticky = root.querySelector('.gnagfri-sticky');
  const mainAdd = root.querySelector('.gnagfri-main-add');
  let stickyVisible;
  const syncSticky = () => {
    const visible = !matchMedia('(min-width:768px)').matches && mainAdd.getBoundingClientRect().bottom <= 0;
    if (visible === stickyVisible) return;
    stickyVisible = visible;
    sticky.hidden = false;
    sticky.inert = !visible;
    sticky.setAttribute('aria-hidden', String(!visible));
    sticky.classList.toggle('is-visible', visible);
  };
  new IntersectionObserver(syncSticky, { threshold: 0 }).observe(mainAdd);
  window.addEventListener('resize', syncSticky, { passive: true });
  window.addEventListener('scroll', syncSticky, { passive: true });
  syncSticky();
  // Native disclosures retain keyboard behavior while height animation supports interruption.
  root.querySelectorAll('details').forEach(details => {
    const summary = details.querySelector('summary'); let animation;
    summary.addEventListener('click', event => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      event.preventDefault();
      const start = details.getBoundingClientRect().height;
      const opening = details.dataset.expanded !== undefined ? details.dataset.expanded !== 'true' : !details.open;
      details.dataset.expanded = String(opening); animation?.cancel(); details.open = true; details.style.height = 'auto';
      const end = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      details.style.overflow = 'hidden';
      animation = details.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: details.classList.contains('gnagfri-purchase-accordion') ? 200 : 300, easing: 'ease-in-out' });
      animation.onfinish = () => { details.open = opening; details.style.height = ''; details.style.overflow = ''; animation = null; };
    });
  });
  root.querySelectorAll('[role="tablist"]').forEach(list => {
    const tabs = [...list.querySelectorAll('[role="tab"]')];
    const select = tab => { tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; const panel = document.getElementById(t.getAttribute('aria-controls')); if (panel) { panel.hidden = !active; if (active && !matchMedia('(prefers-reduced-motion: reduce)').matches) panel.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 250 }); } }); };
    tabs.forEach((tab, index) => { tab.addEventListener('click', () => select(tab)); tab.addEventListener('keydown', event => { let next; if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length]; if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length]; if (event.key === 'Home') next = tabs[0]; if (event.key === 'End') next = tabs.at(-1); if (next) { event.preventDefault(); select(next); next.focus(); } }); });
  });
})();
